import React from "react";

import { Outlet} from "react-router-dom";


function OutletFile() {
  return (
   
    <Outlet />
  );
}

export default OutletFile;
